import PositionsPanel from "../components/terminal/PositionsPanel";
import ClosedPositionsPanel from "../components/terminal/ClosedPositionsPanel";

export default function Positions() {
    return (
        <div className="bg-[#050505] min-h-[calc(100vh-3.5rem)] bg-grid-fine">
            <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10 grid gap-6">
                <div>
                    <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-cyan-400">Positions</div>
                    <h1 className="text-3xl font-medium tracking-tighter mt-2">My BUBE swap activity</h1>
                    <p className="mt-1.5 text-[12px] text-zinc-500 max-w-2xl leading-relaxed">
                        Live swaps are also visible in the terminal. This page is the source of truth for everything you've ever traded — current and closed. Filter, drill in, and export.
                    </p>
                </div>
                <PositionsPanel />
                <ClosedPositionsPanel />
            </div>
        </div>
    );
}
